//import React, { Component } from 'react';
//import Currency from 'react-currency-formatter';
import moment from 'moment';
import somLogoMini from './img/super-cloud-rgb-mini.png';
import config from './config/config.js'
export default somLogoMini;

export function kebabCase(string = '') {
    return string.replace(/\s/g, '-').toLowerCase()
}

export function capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}

// flatten arrays
// taken from here:
// https://stackoverflow.com/questions/10865025/merge-flatten-an-array-of-arrays-in-javascript
export function flatten(arr) {
    return arr.reduce(function (flat, toFlatten) { // this function is the callback performed on each item of the array. flat = accumulator, toFlatten = the current value
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []); // [] is the initial vlaue
}

// get superadmin roleID
export function getRoleID(roleName) {
    const role = config.roles.find(role => role.role === roleName);
    let roleID;
    if (role) {
        roleID = role.roleID;

    }
    return roleID
}

export function validatePasswordComplexity(password) {
    // ensure at least one lowercase, one uppercase, one number, and one special character
    return (password.match(/[^a-zA-Z0-9\s]/g) && password.match(/[a-z]/g) && password.match(/[A-Z]/g) && password.match(/[0-9]/g) && password.length >= 8);
}

// determine, based on subject claim, if this user logged in via social login (e.g. google)
export function isSocialLogin(subjectClaim) {
    if (isEmpty(subjectClaim)) {
        return false;
    }
    // if the subject claim begins with "auth0|" then we know the user logged in via email/password
    return !(subjectClaim.match(/^auth0\|/g));
}


// e.g. turns getFileName("Report Name", "csv") to "report-name-2018-01-01.csv"
export function getExportFileName(title, fileExtension = 'xlsx', orderType = '0', monthYear = '') {
    // get date string
    const d = new Date();
    const year = d.getFullYear();
    const month = ("00" + (d.getMonth() + 1).toString()).slice(-2);
    const day = ("00" + (d.getDate()).toString()).slice(-2);

    //let fileName = `${title.toLowerCase().replace(/\s/g, "-")}`;
    let fileName = `${title.replace(/\s/g, "-")}`;
    switch (fileName) {
        case "top-performers":
            // monthYear is not empty if it hits here
            return `${fileName}-${monthYear.slice(0, 4)}-${monthYear.slice(-2)}.${fileExtension}`
        default:
            switch (parseInt(orderType, 10)) {
                case 1:
                    fileName = `${fileName}-GM`;
                    break;
                case 2:
                    fileName = `${fileName}-P&A`;
                    break;
                default:
                    break;
            }

            return `${fileName}-${year}-${month}-${day}.${fileExtension}`
    }
}

export function removeSpaces(string) {
    return string.replace(/\s/g, "");
}

export function escapeSlashes(string) {
    return string.replace(/\//g, "!!!");
}

export class queryStringBuilder {
    queryString;

    constructor() {
        this.queryString = '';
    }

    append = (key, value) => {
        if (isEmpty(key)) {
            return;
        }
        if (this.queryString.length > 0) {
            this.queryString = `${this.queryString}&${key}=${encodeURIComponent(value)}`;
        } else {
            this.queryString = `?${key}=${encodeURIComponent(value)}`;
        }
    }
}


// convert date object to integer (YYYYMMDD)
export function convertDateToInteger(date) {
    if (date) {
        return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
    } else {
        return null;
    }

}

// convert datestring of format YYYYMMDD to a date object
export function convertDatestampToObject(dateString) {
    if ((/^[0-9]{8}$/).test(dateString)) {

        const year = dateString.toString().substring(0, 4);
        const month = dateString.toString().substring(4, 6);
        const day = dateString.toString().substring(6, 8);

        return new Date(year, month - 1, day);

    } else {
        return null;
    }

}

// turn date string into a date object
export function parseDateString(date) {
    if (isEmpty(date)) return null;

    // check if a date object is what has been passed in
    if (typeof date === "object" && typeof date.getMonth === 'function') return date;

    // ok, it's not a date object, so check whether it's a string
    if (typeof date !== "string") return null;

    // convert date string to millseconds since epoch (jan 1, 1970), then convert to date
    let millisecondsSinceEpoch = Date.parse(date);

    if (!isNaN(millisecondsSinceEpoch)) {
        return new Date(millisecondsSinceEpoch);
    } else
        return null;

}

export function getMinutesInMilliseconds(minutes) {
    return minutes * 60 * 1000;
}

// an epoch is seconds since Jan 1, 1970
export function convertEpochToDate(epoch) {
    return new Date(epoch * 1000);

}

export function decodeJwtToken(token) {
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    } catch (e) {
        return null;
    }
}

export function getMonthsForLast2Years(uiLanguage) {

    let dates = [];

    if (typeof uiLanguage !== 'undefined')
        moment.locale(uiLanguage);

    // start from 2 years ago for production, otherwise 5 years
    let iYear = 2;
    if (process.env.REACT_APP_ENVIRO === "development") {
        iYear = 5;
    } else if (process.env.REACT_APP_ENVIRO === "local") {
        iYear = 5;
    }
    let cursorDate = moment(new Date()).subtract(iYear, 'years');

    // get the next 25 months (i.e. 2 years' worth of months PLUS the current month) 
    // e.g. if it's May 2019, then get all the months from May 2017 - May 2019
    for (let i = 0; i <= iYear * 12; i++) {
        dates.push({ "date": cursorDate.format("MMM YYYY"), "dateID": cursorDate.format("YYYYMM") });
        cursorDate.add(1, 'months');
    }

    return dates;
}

export function getMonths(uiLanguage) {

    let months = [];

    if (typeof uiLanguage !== 'undefined')
        moment.locale(uiLanguage);

    let monthNames = moment.months();

    for (let i = 0; i < 12; i++) {
        months.push({ "monthName": monthNames[i], "monthID": i + 1 });
    }

    return months;
}

export function isEmpty(str) {
    return (!str || str.length === 0);
}

// reference: https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript/5344074#5344074
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function formatMoney(amount, currencyCode = 'USD', languageCode) {
    return (amount).toLocaleString(languageCode, {
        style: "currency",
        currency: currencyCode
    });
}

// get the last calendar month and year in YYYYMM format
// (for instance if it's currently Jan 2019, then this returns 201812)
export function getLastMonthAndYear() {
    //let selectedDateId;

    // get the month+year of the last month
    let date = new Date();
    let year = date.getYear() + 1900; // getYear() returns years since 1900
    let month = date.getMonth() + 1; // since january = 0

    // go back one month
    if (month <= 1) {
        month = 12;
        year--;
    } else {
        month--;
    }

    // construct a date (month + year)
    month = String(month);
    year = String(year);

    // pad the month so it has a zero leading it
    if (month.length === 1) {
        month = "0" + month;
    }

    return year + month;
}

// reference: https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
export function getLocaleDateString() {

    var formats = {
        "ar-SA": "dd/MM/yy",
        "bg-BG": "dd.M.yyyy",
        "ca-ES": "dd/MM/yyyy",
        "zh-TW": "yyyy/M/d",
        "cs-CZ": "d.M.yyyy",
        "da-DK": "dd-MM-yyyy",
        "de-DE": "dd.MM.yyyy",
        "el-GR": "d/M/yyyy",
        "en-US": "M/d/yyyy",
        "fi-FI": "d.M.yyyy",
        "fr-FR": "dd/MM/yyyy",
        "he-IL": "dd/MM/yyyy",
        "hu-HU": "yyyy. MM. dd.",
        "is-IS": "d.M.yyyy",
        "it-IT": "dd/MM/yyyy",
        "ja-JP": "yyyy/MM/dd",
        "ko-KR": "yyyy-MM-dd",
        "nl-NL": "d-M-yyyy",
        "nb-NO": "dd.MM.yyyy",
        "pl-PL": "yyyy-MM-dd",
        "pt-BR": "d/M/yyyy",
        "ro-RO": "dd.MM.yyyy",
        "ru-RU": "dd.MM.yyyy",
        "hr-HR": "d.M.yyyy",
        "sk-SK": "d. M. yyyy",
        "sq-AL": "yyyy-MM-dd",
        "sv-SE": "yyyy-MM-dd",
        "th-TH": "d/M/yyyy",
        "tr-TR": "dd.MM.yyyy",
        "ur-PK": "dd/MM/yyyy",
        "id-ID": "dd/MM/yyyy",
        "uk-UA": "dd.MM.yyyy",
        "be-BY": "dd.MM.yyyy",
        "sl-SI": "d.M.yyyy",
        "et-EE": "d.MM.yyyy",
        "lv-LV": "yyyy.MM.dd.",
        "lt-LT": "yyyy.MM.dd",
        "fa-IR": "MM/dd/yyyy",
        "vi-VN": "dd/MM/yyyy",
        "hy-AM": "dd.MM.yyyy",
        "az-Latn-AZ": "dd.MM.yyyy",
        "eu-ES": "yyyy/MM/dd",
        "mk-MK": "dd.MM.yyyy",
        "af-ZA": "yyyy/MM/dd",
        "ka-GE": "dd.MM.yyyy",
        "fo-FO": "dd-MM-yyyy",
        "hi-IN": "dd-MM-yyyy",
        "ms-MY": "dd/MM/yyyy",
        "kk-KZ": "dd.MM.yyyy",
        "ky-KG": "dd.MM.yy",
        "sw-KE": "M/d/yyyy",
        "uz-Latn-UZ": "dd/MM yyyy",
        "tt-RU": "dd.MM.yyyy",
        "pa-IN": "dd-MM-yy",
        "gu-IN": "dd-MM-yy",
        "ta-IN": "dd-MM-yyyy",
        "te-IN": "dd-MM-yy",
        "kn-IN": "dd-MM-yy",
        "mr-IN": "dd-MM-yyyy",
        "sa-IN": "dd-MM-yyyy",
        "mn-MN": "yy.MM.dd",
        "gl-ES": "dd/MM/yy",
        "kok-IN": "dd-MM-yyyy",
        "syr-SY": "dd/MM/yyyy",
        "dv-MV": "dd/MM/yy",
        "ar-IQ": "dd/MM/yyyy",
        "zh-CN": "yyyy/M/d",
        "de-CH": "dd.MM.yyyy",
        "en-GB": "dd/MM/yyyy",
        "es-MX": "dd/MM/yyyy",
        "fr-BE": "d/MM/yyyy",
        "it-CH": "dd.MM.yyyy",
        "nl-BE": "d/MM/yyyy",
        "nn-NO": "dd.MM.yyyy",
        "pt-PT": "dd-MM-yyyy",
        "sr-Latn-CS": "d.M.yyyy",
        "sv-FI": "d.M.yyyy",
        "az-Cyrl-AZ": "dd.MM.yyyy",
        "ms-BN": "dd/MM/yyyy",
        "uz-Cyrl-UZ": "dd.MM.yyyy",
        "ar-EG": "dd/MM/yyyy",
        "zh-HK": "d/M/yyyy",
        "de-AT": "dd.MM.yyyy",
        "en-AU": "d/MM/yyyy",
        "es-ES": "dd/MM/yyyy",
        "fr-CA": "yyyy-MM-dd",
        "sr-Cyrl-CS": "d.M.yyyy",
        "ar-LY": "dd/MM/yyyy",
        "zh-SG": "d/M/yyyy",
        "de-LU": "dd.MM.yyyy",
        "en-CA": "M/d/yyyy",
        "es-GT": "dd/MM/yyyy",
        "fr-CH": "dd.MM.yyyy",
        "ar-DZ": "dd-MM-yyyy",
        "zh-MO": "d/M/yyyy",
        "de-LI": "dd.MM.yyyy",
        "en-NZ": "d/MM/yyyy",
        "es-CR": "dd/MM/yyyy",
        "fr-LU": "dd/MM/yyyy",
        "ar-MA": "dd-MM-yyyy",
        "en-IE": "dd/MM/yyyy",
        "es-PA": "MM/dd/yyyy",
        "fr-MC": "dd/MM/yyyy",
        "ar-TN": "dd-MM-yyyy",
        "en-ZA": "yyyy/MM/dd",
        "es-DO": "dd/MM/yyyy",
        "ar-OM": "dd/MM/yyyy",
        "en-JM": "dd/MM/yyyy",
        "es-VE": "dd/MM/yyyy",
        "ar-YE": "dd/MM/yyyy",
        "en-029": "MM/dd/yyyy",
        "es-CO": "dd/MM/yyyy",
        "ar-SY": "dd/MM/yyyy",
        "en-BZ": "dd/MM/yyyy",
        "es-PE": "dd/MM/yyyy",
        "ar-JO": "dd/MM/yyyy",
        "en-TT": "dd/MM/yyyy",
        "es-AR": "dd/MM/yyyy",
        "ar-LB": "dd/MM/yyyy",
        "en-ZW": "M/d/yyyy",
        "es-EC": "dd/MM/yyyy",
        "ar-KW": "dd/MM/yyyy",
        "en-PH": "M/d/yyyy",
        "es-CL": "dd-MM-yyyy",
        "ar-AE": "dd/MM/yyyy",
        "es-UY": "dd/MM/yyyy",
        "ar-BH": "dd/MM/yyyy",
        "es-PY": "dd/MM/yyyy",
        "ar-QA": "dd/MM/yyyy",
        "es-BO": "dd/MM/yyyy",
        "es-SV": "dd/MM/yyyy",
        "es-HN": "dd/MM/yyyy",
        "es-NI": "dd/MM/yyyy",
        "es-PR": "dd/MM/yyyy",
        "am-ET": "d/M/yyyy",
        "tzm-Latn-DZ": "dd-MM-yyyy",
        "iu-Latn-CA": "d/MM/yyyy",
        "sma-NO": "dd.MM.yyyy",
        "mn-Mong-CN": "yyyy/M/d",
        "gd-GB": "dd/MM/yyyy",
        "en-MY": "d/M/yyyy",
        "prs-AF": "dd/MM/yy",
        "bn-BD": "dd-MM-yy",
        "wo-SN": "dd/MM/yyyy",
        "rw-RW": "M/d/yyyy",
        "qut-GT": "dd/MM/yyyy",
        "sah-RU": "MM.dd.yyyy",
        "gsw-FR": "dd/MM/yyyy",
        "co-FR": "dd/MM/yyyy",
        "oc-FR": "dd/MM/yyyy",
        "mi-NZ": "dd/MM/yyyy",
        "ga-IE": "dd/MM/yyyy",
        "se-SE": "yyyy-MM-dd",
        "br-FR": "dd/MM/yyyy",
        "smn-FI": "d.M.yyyy",
        "moh-CA": "M/d/yyyy",
        "arn-CL": "dd-MM-yyyy",
        "ii-CN": "yyyy/M/d",
        "dsb-DE": "d. M. yyyy",
        "ig-NG": "d/M/yyyy",
        "kl-GL": "dd-MM-yyyy",
        "lb-LU": "dd/MM/yyyy",
        "ba-RU": "dd.MM.yy",
        "nso-ZA": "yyyy/MM/dd",
        "quz-BO": "dd/MM/yyyy",
        "yo-NG": "d/M/yyyy",
        "ha-Latn-NG": "d/M/yyyy",
        "fil-PH": "M/d/yyyy",
        "ps-AF": "dd/MM/yy",
        "fy-NL": "d-M-yyyy",
        "ne-NP": "M/d/yyyy",
        "se-NO": "dd.MM.yyyy",
        "iu-Cans-CA": "d/M/yyyy",
        "sr-Latn-RS": "d.M.yyyy",
        "si-LK": "yyyy-MM-dd",
        "sr-Cyrl-RS": "d.M.yyyy",
        "lo-LA": "dd/MM/yyyy",
        "km-KH": "yyyy-MM-dd",
        "cy-GB": "dd/MM/yyyy",
        "bo-CN": "yyyy/M/d",
        "sms-FI": "d.M.yyyy",
        "as-IN": "dd-MM-yyyy",
        "ml-IN": "dd-MM-yy",
        "en-IN": "dd-MM-yyyy",
        "or-IN": "dd-MM-yy",
        "bn-IN": "dd-MM-yy",
        "tk-TM": "dd.MM.yy",
        "bs-Latn-BA": "d.M.yyyy",
        "mt-MT": "dd/MM/yyyy",
        "sr-Cyrl-ME": "d.M.yyyy",
        "se-FI": "d.M.yyyy",
        "zu-ZA": "yyyy/MM/dd",
        "xh-ZA": "yyyy/MM/dd",
        "tn-ZA": "yyyy/MM/dd",
        "hsb-DE": "d. M. yyyy",
        "bs-Cyrl-BA": "d.M.yyyy",
        "tg-Cyrl-TJ": "dd.MM.yy",
        "sr-Latn-BA": "d.M.yyyy",
        "smj-NO": "dd.MM.yyyy",
        "rm-CH": "dd/MM/yyyy",
        "smj-SE": "yyyy-MM-dd",
        "quz-EC": "dd/MM/yyyy",
        "quz-PE": "dd/MM/yyyy",
        "hr-BA": "d.M.yyyy.",
        "sr-Latn-ME": "d.M.yyyy",
        "sma-SE": "yyyy-MM-dd",
        "en-SG": "d/M/yyyy",
        "ug-CN": "yyyy-M-d",
        "sr-Cyrl-BA": "d.M.yyyy",
        "es-US": "M/d/yyyy"

    };



    return formats[navigator.language] || formats["en-US"];

}




// WEBPACK FOOTER //
// ./src/helpers.js